import React from 'react'
import { PolicyListCard } from '../PolicyListCard'
import { Grid } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { NoPoliciesCard } from '../NoPoliciesCard'
import NewFillButton from '../../Core/NewFillButton'

export const ActivePoliciesList = ({
  policies,
  selectable = false,
  onPolicySelect,
}) => {
  const matches = useMediaQuery('(min-width:1150px)')
  const small = matches && policies.length > 1
  return (
    <Grid container spacing={4}>
      {policies.map((item, index) => (
        <Grid key={index} xs={12} md={small ? 6 : 12} item>
          <PolicyListCard
            buttons={
              selectable ? (
                <NewFillButton
                  green
                  onClick={() => onPolicySelect(item, index)}>
                  Choose this policy
                </NewFillButton>
              ) : undefined
            }
            selectable={selectable}
            small={small}
            key={index}
            insurance={item}
          />
        </Grid>
      ))}
      {policies.length == 0 && (
        <Grid xs={12} md={6} item>
          {' '}
          <NoPoliciesCard />{' '}
        </Grid>
      )}
    </Grid>
  )
}
